import { IDataMessage, Part } from '@/app/chat/group-chat/ItemChat';
import LoadingGenerating from '@/contents/gen-model/contentFeed/LoadingGenerating';
import useViewMoreLess from '@/hooks/useViewMoreLess';
import React from 'react';

interface PromptChatProps {
  message: IDataMessage;
  index: number;
  part: Part;
}

const PromptChat: React.FC<PromptChatProps> = ({ message, index, part }) => {
  const { expanded, toggleExpanded, textRef, shouldShowButton } = useViewMoreLess({
    maxLines: 2,
  });
  return (
    <>
      <span key={index}>
        {message?.processingAsset && (
          <span className="text-[14px] font-bold">
            <span className="underline">Prompt</span>:{' '}
          </span>
        )}
        {part.value.slice(0, 10)?.toLocaleLowerCase() === '/promptsd ' ||
        part.value.slice(0, 10)?.toLocaleLowerCase() === '/promptxl ' ? (
          <>
            <p ref={textRef} className="w-[200px]">
              {part.value.slice(10)}
            </p>
            {shouldShowButton && (
              <p className="cursor-pointer text-12 hover:underline" onClick={toggleExpanded}>
                {expanded ? 'Hide' : 'More'}
              </p>
            )}
          </>
        ) : (
          part.value
        )}
      </span>
      {(part.value.slice(0, 10)?.toLocaleLowerCase() === '/promptsd ' ||
        part.value.slice(0, 10)?.toLocaleLowerCase() === '/promptxl ') &&
        !message?.processingAsset && <LoadingGenerating noPercentage classString="w-[195px]" />}
    </>
  );
};

export default PromptChat;
